export const destinations = {
    title: "Destinos",
    sortName: "Nome",
    noResults: "Nenhum resultado",
    tryDifferentSearch: "Tente uma pesquisa diferente"
};
